// Full-document render of the Oscar address-delete confirm view: PageSkeleton
// wrapping AddressDeletePageBody.
import React from "react";

import { templates } from "@reactivated";

import { AddressDeletePageBody } from "../components/AddressDeletePageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AddressDeleteDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AddressDeletePageBody {...props} />
    </PageSkeleton>
);
